import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const TermsOfServicePage = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1>Terms and Conditions</h1>
          <p className="last-updated">Last updated: June 17th, 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <p>
              These Terms and Conditions constitute a legally binding agreement made between you, whether personally or on
              behalf of an entity ("you") and Fagi Errands Limited ("we," "us" or "our"), concerning your access to and
              use of the Fagi Errands website and mobile application, as well as any other media form, media channel,
              mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the "Site").
            </p>
            <p>
              You agree that by accessing the Site, you have read, understood, and agree to be bound by all of these Terms
              and Conditions. If you do not agree with all of these Terms and Conditions, then you are expressly prohibited
              from using the Site and you must discontinue use immediately.
            </p>
            <p>
              We reserve the right, in our sole discretion, to make changes or modifications to these Terms and Conditions
              at any time and for any reason. We will alert you about any changes by updating the "Last updated" date. It
              is your responsibility to periodically review these Terms and Conditions to stay informed of updates.
            </p>
            <p>
              This Application is intended for users who are at least 13 years of age. All users who are minors in the
              jurisdiction in which they reside (generally under the age of 18) must have the permission of, and be
              directly supervised by, their parent or guardian to use the Site.
            </p>
          </section>

          <section className="legal-section">
            <h2>1. Scope of Services</h2>
            <p>
              Fagi Errands is a digital platform designed to provide users with on-demand errand services through a mobile
              app available on Android and iOS. The services offered include, but are not limited to, shopping errands,
              banking tasks, parcel and cargo deliveries, and home services such as plumbing, electrical work, and
              landscaping. These services are carried out by trained, vetted personnel who are coordinated in real-time
              via the application.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Payments and Fees</h2>
            <p>
              All payments must be made through the app's secure, integrated platforms, which include M-Pesa, Visa, and
              Global Pay. For shopping errands, clients are required to pay 30% of the estimated shopping amount upfront
              as a commitment fee. The remaining 70%, along with a delivery fee, becomes payable upon successful delivery.
            </p>
            <p>
              Receipts from the shopping venue are scanned and uploaded to the app by the service provider, and clients
              receive an auto-generated digital receipt via the app. For services like plumbing, electrical work, and
              landscaping, clients are required to pay a flat facilitation fee of KES 500 upfront. All delivery errands
              are priced dynamically based on distance and real-time traffic, with cost estimates provided before
              confirmation.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Cancellations and Refunds</h2>
            <p>
              In cases where a client cancels a service after it has been assigned, a full refund may not be guaranteed.
              For non-perishable goods, items will be stored at a designated location free of charge for up to three days.
              From the fourth to the seventh day, a daily storage fee will apply. Items unclaimed after seven days will be
              considered forfeited, and a 30% processing fee will be deducted from the original payment.
            </p>
            <p>
              Perishable goods must be collected within their natural freshness window, and any losses due to spoilage are
              the responsibility of the client. No refunds will be issued for perishables that are not collected on time.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Liability and Damage Policy</h2>
            <p>
              Clients are required to declare the condition, value, and nature of goods being transported, particularly
              for package or cargo deliveries. Clients are encouraged to upload clear photographs of their goods before
              handover. If an item is damaged, the client must report it immediately through the app's "Report Issue"
              feature before completing the final payment.
            </p>
            <p>
              Reports must include a description of the damage, supporting images or videos, and the timestamp of the
              incident. Fagi Errands will conduct a full investigation within seven days. If the fault lies with the
              service provider, the company will facilitate compensation. If the client failed to provide accurate
              information or if the damage was due to external, uncontrollable factors such as riots or traffic
              accidents, no compensation will be issued.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Intellectual Property Rights</h2>
            <p>
              Unless otherwise indicated, the Site is our proprietary property and all source code, databases,
              functionality, software, website designs, audio, video, text, photographs, and graphics on the Site
              (collectively, the "Content") and the trademarks, service marks, and logos contained therein (the "Marks")
              are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and
              various other intellectual property rights and unfair competition laws of Kenya, foreign jurisdictions,
              and international conventions.
            </p>
            <p>
              The Content and the Marks are provided on the Site "AS IS" for your information and personal use only.
              No part of the Site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded,
              posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise
              exploited for any commercial purpose whatsoever, without our express prior written permission.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. User Representations</h2>
            <p>By using the Site, you represent and warrant that:</p>
            <ul>
              <li>All registration information you submit will be true, accurate, current, and complete.</li>
              <li>You will maintain the accuracy of such information and promptly update it as necessary.</li>
              <li>You have the legal capacity and you agree to comply with these Terms and Conditions.</li>
              <li>You are not under the age of 13.</li>
              <li>You will not access the Site through automated or non-human means, whether through a bot, script, or otherwise.</li>
              <li>You will not use the Site for any illegal or unauthorized purpose.</li>
              <li>Your use of the Site will not violate any applicable law or regulation.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. User Registration</h2>
            <p>
              You may be required to register with the Site. You agree to keep your password confidential and will be
              responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a
              username you select if we determine, in our sole discretion, that such username is inappropriate, obscene,
              or otherwise objectionable.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Prohibited Activities</h2>
            <p>
              You may not access or use the Site for any purpose other than that for which we make the Site available.
              As a user of the Site, you agree not to:
            </p>
            <ul>
              <li>Systematically retrieve data or other content from the Site to create or compile a collection, database, or directory without written permission from us.</li>
              <li>Make any unauthorized use of the Site, including collecting usernames and/or email addresses by electronic means for the purpose of sending unsolicited email.</li>
              <li>Circumvent, disable, or otherwise interfere with security-related features of the Site.</li>
              <li>Engage in unauthorized framing of or linking to the Site.</li>
              <li>Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information.</li>
              <li>Interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.</li>
              <li>Attempt to impersonate another user or person or use the username of another user.</li>
              <li>Use the Site for any revenue-generating endeavor or commercial enterprise not approved by us.</li>
              <li>Decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.</li>
              <li>Use the Site in a manner inconsistent with any applicable laws or regulations.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Guidelines for Reviews</h2>
            <p>
              After every completed service, clients are required to rate service providers based on timeliness,
              professionalism, and the quality of service rendered. Similarly, service providers are encouraged to rate
              clients on clear communication, prompt payments, and the overall interaction.
            </p>
            <p>
              When posting a review, you must comply with the following criteria: your review must reflect firsthand
              experience; it must not contain offensive, abusive, racist, or hate language; it must not contain
              discriminatory references; and you may not post any false or misleading statements.
            </p>
            <p>
              Providers with consistently high ratings (4.5 stars and above) will receive priority in task assignments
              and financial incentives. Clients who maintain a good rating history may receive occasional discounts and
              reward vouchers.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Mobile Application License</h2>
            <p>
              If you access the Site via a mobile application, then we grant you a revocable, non-exclusive,
              non-transferable, limited right to install and use the mobile application on wireless electronic devices
              owned or controlled by you, and to access and use the mobile application strictly in accordance with the
              terms and conditions of this mobile application license.
            </p>
            <p>You shall not:</p>
            <ul>
              <li>Decompile, reverse engineer, disassemble, or attempt to derive the source code of the application.</li>
              <li>Make any modification, adaptation, improvement, enhancement, translation, or derivative work from the application.</li>
              <li>Violate any applicable laws, rules, or regulations in connection with your access or use of the application.</li>
              <li>Use the application for any revenue generating endeavor, commercial enterprise, or other purpose for which it is not designed or intended.</li>
              <li>Use the application to send automated queries to any website or to send any unsolicited commercial e-mail.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>11. Privacy Policy</h2>
            <p>
              We care about data privacy and security. Please review our{' '}
              <Link to="/privacy">Privacy Policy</Link>. By using the Site, you agree to be bound by our Privacy Policy,
              which is incorporated into these Terms and Conditions. The Site is hosted in Kenya. If you access the Site
              from other regions with different data protection laws, through your continued use of the Site, you are
              transferring your data to Kenya and expressly consenting to have your data transferred to and processed
              in Kenya.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Term and Termination</h2>
            <p>
              These Terms and Conditions shall remain in full force and effect while you use the Site. We reserve the
              right, in our sole discretion and without notice or liability, to deny access to and use of the Site to
              any person for any reason, including without limitation for breach of any representation, warranty, or
              covenant contained in these Terms and Conditions.
            </p>
            <p>
              If we terminate or suspend your account for any reason, you are prohibited from registering and creating
              a new account under your name, a fake or borrowed name, or the name of any third party. We reserve the
              right to take appropriate legal action, including without limitation pursuing civil, criminal, and
              injunctive redress.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Disclaimer</h2>
            <p>
              THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, WE
              DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING,
              WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
              NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE
              SITE'S CONTENT AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY ERRORS, MISTAKES, OR
              INACCURACIES OF CONTENT AND MATERIALS.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Governing Law</h2>
            <p>
              These Terms and Conditions and your use of the Site are governed by and construed in accordance with the
              laws of Kenya applicable to agreements made and to be entirely performed within the Republic of Kenya,
              without regard to its conflict of law principles.
            </p>
          </section>

          <section className="legal-section">
            <h2>15. Contact Us</h2>
            <p>
              In order to resolve a complaint regarding the Site or to receive further information regarding use of the
              Site, please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Corporate Address:</strong> Next Gen Mall, Mombasa Road, 3rd Floor, Nairobi, Kenya</p>
              <p><strong>Email:</strong> <a href="mailto:contact.support@fagierrands.com">contact.support@fagierrands.com</a></p>
              <p><strong>Phone:</strong> <a href="tel:+254748370829">+254 748 370 829</a></p>
            </div>
          </section>
        </div>

        <div className="legal-footer">
          <Link to="/" className="back-link">← Back to Home</Link>
          <div>
            <Link to="/privacy" className="related-link">Privacy Policy</Link>
            <Link to="/how-to-delete-account" className="related-link" style={{ marginLeft: '1rem' }}>How to Delete Account</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
